import { Injectable } from '@angular/core';
import { PaginationModel, RequestParamModel } from '@coreModels';
import { ApiConstants } from '@coreConstant';
import { catchError, map, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FAQsService {

  constructor(
    private http: HttpClient
  ) {
  }

  /**
   * This method is used to get list of faqs
   * @param requestParamModel
   * @returns
   */
  getFAQs(requestParamModel: RequestParamModel): any {
    return this.http.get(ApiConstants.FAQ_LIST_URL + requestParamModel?.getParams(), { observe: 'response' })
      .pipe(map((response: any) => {
        const responseList = new PaginationModel<any>();
        const headers = response.headers;
        responseList.setHeaders(headers);
        responseList.data = response.body.data as any[];
        return responseList;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }

  getFaqCategoryList(requestParaModel?: RequestParamModel) {
    return this.http.get(ApiConstants.API_CONSTANTS_FOR_FAQ_CATEGORY +  requestParaModel?.getParams(), { observe: 'response' })
    .pipe(
      map((response: any) => {
        const faqCategoryList = new PaginationModel<any>();
        const headers = response.headers;
        faqCategoryList.setHeaders(headers);
        faqCategoryList.data = response.body.data as any[];
        return faqCategoryList;
      }),
      catchError(err => throwError(() => err))
    );
  }

}
